<template>
	<div class="m-2">
		<div class="auto-grid gap-2">
			<SoftSelect
				v-model="dynamicImage"
				class="grow"
				:items="dynamicImages || []"
				itemText="name"
				itemValue="id"
				:label="$t('dashboard.plugins.dynamicImage')"
			/>
			<PeriodSelection
				v-model="period"
				class="grow"
				:label="$t('common.period', 1)"
				:header="false"
				hideDetails
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { useSiteDynamicImages } from "@/api/dynamic-image-query";
import PeriodSelection from "@/components/helpers/PeriodSelection";
import { mdiPlus } from "@mdi/js";
import { PropType, computed, defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import {
	DynamicImageDataOptions,
	defaultDynamicImageDataOptions,
} from "./dynamic-image-data-options";

export default defineComponent({
	components: { PeriodSelection },
	name: "DynamicImageDataConfig",
	data: () => ({
		mdiPlus,
	}),
	props: {
		modelValue: {
			type: Object as PropType<DynamicImageDataOptions>,
			default: () => ({ ...defaultDynamicImageDataOptions }),
		},
	},
	setup(props) {
		const valueModel = useVModel(props);
		const dynamicImage = toRef(valueModel.value, "dynamicImage");
		const period = toRef(valueModel.value, "period");

		const route = useRoute();
		const projectId = computed(() => route.params.id as string);

		const { data: dynamicImages } = useSiteDynamicImages(projectId);

		const dynamicImageDialog = ref(false);
		const openDynamicImageDialog = () => {
			dynamicImageDialog.value = true;
		};

		return {
			period,
			dynamicImage,
			dynamicImages,
			dynamicImageDialog,
			openDynamicImageDialog,
		};
	},
});
</script>
